import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { offerBatchUploadSpuIdQuery } from './type';

/**
 * 账号、金币、装备、Boosting 业务下载模版时根据游戏id 和 业务id 获取spuId
  GET /product/offerManage/getSpuData
  接口ID：268956409
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-268956409
 */
export const getOfferBatchUploadSpuId = (params: offerBatchUploadSpuIdQuery): AxiosPromise<{ id: string }> => {
  return request({
    url: '/product/offerManage/getSpuData',
    method: 'get',
    params
  });
};
